module.exports = __webpack_public_path__ + "static/media/waitlist-member-8.dd98d541.jpeg";